"use es6";

const isBrowser = typeof document !== "undefined";
export { isBrowser };